import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=1488a4a4&"
import script from "./Backups.vue?vue&type=script&lang=js&"
export * from "./Backups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports